import React, { useCallback, useContext, useRef } from 'react';
import { OptionChip } from '@move-ui/chip';
import { mergeRefs } from '@move-web-essentials-utils/ref';
import styles from './MultiSelectItem.module.css';
import { MultiSelectContext } from './MultiSelectContext';
export const MultiSelectItem = ({ label, value, render = (renderLabel) => renderLabel, className, setInputRef, chip: Chip = OptionChip, icon }) => {
    const ref = useRef(null);
    const focusInput = useCallback(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    const { selectedValues, name, onChange } = useContext(MultiSelectContext);
    const isChecked = selectedValues.includes(value);
    return (React.createElement("li", { className: styles.component },
        React.createElement(Chip, { name: name, className: className, id: `${name}-${value}`, value: value, isSet: isChecked, onClick: onChange, onLabelClick: focusInput, inputRef: mergeRefs(ref, setInputRef), icon: icon }, render(label, value, isChecked))));
};
//# sourceMappingURL=MultiSelectItem.js.map